var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-clipboard-demo"}},[_c('clipboard-directive'),_c('clipboard-without-directive')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }